/**
 * Utility functions for handling sorting in API requests
 */

/**
 * Constructs an order parameter for API requests based on field names and directions
 *
 * @param fieldNames - Array of field names or comma-separated string of field names
 * @param directions - Array of directions ('asc' or 'desc') or comma-separated string of directions
 * @param getOrderField - Optional function to transform field names (e.g., for Jobs API)
 * @returns Order parameter string in the format "field1,-field2,field3"
 */
export const constructOrderParameter = (
  fieldNames: string | string[] | null,
  directions: string | string[] | null,
  getOrderField?: (field: string) => string,
): string => {
  if (!fieldNames) return "";

  const fields = Array.isArray(fieldNames)
    ? fieldNames
    : typeof fieldNames === "string"
      ? fieldNames.split(",")
      : [];

  const dirs = Array.isArray(directions)
    ? directions
    : typeof directions === "string"
      ? directions.split(",")
      : [];

  if (fields.length > 1) {
    return fields
      .map((field, index) => {
        const orderField = getOrderField ? getOrderField(field) : field;
        const direction = dirs[index] || dirs[0] || "asc";
        return `${direction === "desc" ? "-" : ""}${orderField}`;
      })
      .join(",");
  } else if (fields.length === 1) {
    const field = fields[0];
    const direction = dirs[0] || "asc";
    const orderField = getOrderField ? getOrderField(field) : field;
    return `${direction === "desc" ? "-" : ""}${orderField}`;
  }

  return "";
};
